import apiService from 'config/service';
import { PurchaseExtraSuggestedTruckersProps } from './types';

export const purchaseExtraSuggestedTruckers = ({ freightId }: PurchaseExtraSuggestedTruckersProps): Promise<void> =>
  apiService.post(`/pay-per-use/extra-suggested-truckers`, {
    freightId,
  });
